import { create } from 'zustand'

type Theme = 'light' | 'dark' | 'matrix' | 'midnight' | 'system'

const THEME_STORAGE_KEY = 'xenon-flex-theme-preference'

function loadTheme(): Theme {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY)
    if (stored === 'dark' || stored === 'matrix' || stored === 'midnight' || stored === 'system') {
      return stored
    }
    return 'light'
  } catch (error) {
    console.error('[ThemeStore] Failed to load theme:', error)
    return 'light'
  }
}

function saveTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme)
  } catch (error) {
    console.error('[ThemeStore] Failed to save theme:', error)
  }
}

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: loadTheme(),

  setTheme: (theme: Theme) => {
    saveTheme(theme)
    set({ theme })
  },

  toggleTheme: () => {
    const currentTheme = get().theme
    const newTheme =
      currentTheme === 'light' ? 'dark' :
      currentTheme === 'dark' ? 'midnight' :
      currentTheme === 'midnight' ? 'matrix' :
      currentTheme === 'matrix' ? 'system' :
      'light'
    saveTheme(newTheme)
    set({ theme: newTheme })
  },
}))